<!--<app-sidenav [collapsed]="sideNavVisible$ | async"></app-sidenav>-->
<div class="content flex">
  <p class="govuk-body-l">An unexpected error has occured. Please try again in a few minutes</p>
  <p><a id="searchWithDifferentIdLink" routerLink="/manage-org/register/search"> Search with a different organisation ID</a></p>
  <p><a id="submitClaimLink" href="https://www.gca.gov.uk/contact" target="_blank">Contact GCA</a></p>
</div>
